import { useMemo } from 'react';

export const useBillboardClassNames = (vehicleImage: string | null) =>
    useMemo<string>(() => {
        const classes = ['feature-guide-billboard--wrap'];
        if (!vehicleImage) classes.push('dyf-no-vehicle-image');
        return classes.join(' ');
    }, [vehicleImage]);
